import { render } from "./CreatePurchaseOrderItemModal.vue?vue&type=template&id=d9a71f36&scoped=true"
import script from "./CreatePurchaseOrderItemModal.vue?vue&type=script&lang=ts"
export * from "./CreatePurchaseOrderItemModal.vue?vue&type=script&lang=ts"

import "./CreatePurchaseOrderItemModal.vue?vue&type=style&index=0&id=d9a71f36&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d9a71f36"

export default script